import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import ConnectToolsModal from '../ConnectToolsModal';
import { OPEN_GLOBAL_FEEDBACK_EVENT } from '../../common/GlobalFeedbackButton';
import {
  XMarkIcon,
  ChevronRightIcon,
  ArrowTopRightOnSquareIcon,
  DocumentDuplicateIcon,
} from '@heroicons/react/24/outline';
import axios from 'axios';
import { toast } from 'react-hot-toast';

import gmailSvg from '../../../assets/gmail.svg';
import googleCalendarSvg from '../../../assets/google-calendar.svg';
import driveSvg from '../../../assets/drive.svg';
import outlookSvg from '../../../assets/outlook.svg';
import outlookCalendarSvg from '../../../assets/outlook-calendar.svg';
import sharepointSvg from '../../../assets/sharepoint.svg';
import onedriveSvg from '../../../assets/onedrive.svg';
import { TbPlug } from 'react-icons/tb';
import { FaGithub } from 'react-icons/fa';
import { SiNotion } from 'react-icons/si';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8081/api';

const HubSpotIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 489 511.8" className="w-full h-full" {...props}>
    <path fill="#FF7A59" fillRule="nonzero" d="M375.25 168.45V107.5c16.43-7.68 26.97-24.15 27.08-42.29V63.8c0-25.95-21.05-46.99-47-46.99h-1.37c-25.95 0-46.99 21.04-46.99 46.99v1.41a46.985 46.985 0 0027.29 42.3v60.94c-23.13 3.53-44.98 13.18-63.19 27.84L103.88 66.16c1.19-4.29 1.83-8.73 1.89-13.17v-.11C105.77 23.68 82.09 0 52.88 0 23.68 0 0 23.68 0 52.88c0 29.18 23.64 52.85 52.81 52.89 9.17-.08 18.16-2.59 26.06-7.23l164.62 128.07a133.501 133.501 0 00-22.16 73.61c0 27.39 8.46 54.17 24.18 76.58l-50.06 50.06a43.926 43.926 0 00-12.43-1.81c-23.96 0-43.38 19.42-43.38 43.37 0 23.96 19.42 43.38 43.38 43.38 23.95 0 43.37-19.42 43.37-43.38v-.13a41.81 41.81 0 00-2.02-12.5l49.52-49.56a133.687 133.687 0 0081.54 27.78c73.76 0 133.57-59.81 133.57-133.57 0-66.05-48.3-122.2-113.61-132.06l-.14.07zm-20.39 200.4c-36.79-1.52-65.85-31.79-65.85-68.62 0-35.43 26.97-65.06 62.23-68.38h3.62c35.8 2.73 63.46 32.58 63.46 68.48 0 35.91-27.66 65.76-63.45 68.48l-.01.04zm0 0z" />
  </svg>
);

const CONNECTOR_APPS = [
  { id: 'google-drive', name: 'Google Drive', label: 'Google Drive', src: driveSvg, description: 'Access files and documents in Drive', connectorType: 'App', author: 'Midus', uuid: 'a1b2c3d4-e5f6-4a5b-8c9d-0e1f2a3b4c5d', website: 'https://drive.google.com', privacyPolicy: 'https://heymidus.com/privacy' },
  { id: 'gmail', name: 'Gmail', label: 'Gmail', src: gmailSvg, description: 'Search, read, and send emails', connectorType: 'App', author: 'Midus', uuid: 'c7e2f1a4-9b3d-4e8a-a6c5-2d1f0b9e8c7a', website: 'https://gmail.com', privacyPolicy: 'https://heymidus.com/privacy' },
  { id: 'google-calendar', name: 'Google Calendar', label: 'Google Calendar', src: googleCalendarSvg, description: 'View and manage calendar events', connectorType: 'App', author: 'Midus', uuid: 'c3d4e5f6-a7b8-6c7d-0e1f-2a3b4c5d6e7f', website: 'https://calendar.google.com', privacyPolicy: 'https://heymidus.com/privacy' },
  { id: 'outlook-calendar', name: 'Outlook Calendar', label: 'Outlook Calendar', src: outlookCalendarSvg, description: 'View and manage Outlook calendar events', connectorType: 'App', author: 'Midus', uuid: 'e5f6a7b8-c9d0-8e9f-2a3b-4c5d6e7f8a9b', website: 'https://outlook.com', privacyPolicy: 'https://heymidus.com/privacy' },
  { id: 'outlook-mail', name: 'Outlook Mail', label: 'Outlook Mail', src: outlookSvg, description: 'Search, read, and send Outlook emails', connectorType: 'App', author: 'Midus', uuid: 'd4e5f6a7-b8c9-7d8e-1f2a-3b4c5d6e7f8a', website: 'https://outlook.com', privacyPolicy: 'https://heymidus.com/privacy' },
  { id: 'sharepoint', name: 'SharePoint', label: 'SharePoint', src: sharepointSvg, description: 'Search and read files from SharePoint sites', connectorType: 'App', author: 'Midus', uuid: 'f5e6d7c8-b9a0-9e8f-7d6c-5b4a3e2d1c0b', website: 'https://sharepoint.com', privacyPolicy: 'https://heymidus.com/privacy' },
  { id: 'onedrive', name: 'OneDrive', label: 'OneDrive', src: onedriveSvg, description: 'Search and read files from your OneDrive', connectorType: 'App', author: 'Midus', uuid: 'e6f7d8c9-a0b1-0f9e-8d7c-6b5a4f3e2d1c', website: 'https://onedrive.com', privacyPolicy: 'https://heymidus.com/privacy' },
  { id: 'hubspot', name: 'HubSpot', label: 'HubSpot', icon: HubSpotIcon, description: 'Query contacts, deals, companies, and more from HubSpot CRM', connectorType: 'App', author: 'HubSpot', uuid: 'b2c3d4e5-f6a7-5b6c-9d0e-1f2a3b4c5d6e', website: 'https://hubspot.com', privacyPolicy: 'https://legal.hubspot.com/privacy-policy' },
  { id: 'github', name: 'GitHub', label: 'GitHub', icon: FaGithub, description: 'List repos, search issues, read files, and manage pull requests', connectorType: 'App', author: 'Midus', uuid: 'f6a7b8c9-d0e1-9f0a-3b4c-5d6e7f8a9b0c', website: 'https://github.com', privacyPolicy: 'https://heymidus.com/privacy' },
  { id: 'notion', name: 'Notion', label: 'Notion', icon: SiNotion, description: 'Search pages, read notes, and query databases in your workspace', connectorType: 'App', author: 'Midus', uuid: 'a7b8c9d0-e1f2-0a1b-4c5d-6e7f8a9b0c1d', website: 'https://notion.so', privacyPolicy: 'https://heymidus.com/privacy' },
];

const getDisconnectEndpoint = (connectorId) => {
  const map = {
    'google-drive': `${API_URL}/auth/google-drive/disconnect`,
    gmail: `${API_URL}/auth/google-drive/disconnect?connector=gmail`,
    'google-calendar': `${API_URL}/auth/google-drive/disconnect?connector=calendar`,
    'outlook-mail': `${API_URL}/auth/outlook/disconnect`,
    'outlook-calendar': `${API_URL}/auth/outlook-calendar/disconnect`,
    sharepoint: `${API_URL}/auth/sharepoint/disconnect`,
    onedrive: `${API_URL}/auth/onedrive/disconnect`,
    hubspot: `${API_URL}/auth/hubspot/disconnect`,
    github: `${API_URL}/auth/github/disconnect`,
    notion: `${API_URL}/auth/notion/disconnect`,
  };
  return map[connectorId];
};

function ConnectorDetailModal({ connector, onClose, onDisconnect, disconnecting, darkMode }) {
  if (!connector) return null;
  const IconComponent = connector.icon;
  const imgSrc = connector.src;

  const detailContent = (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center px-4">
      <div
        className="absolute inset-0 bg-black/50 dark:bg-black/70 backdrop-blur-sm"
        onClick={onClose}
        aria-hidden="true"
      />
      <div
        className="account-modal relative w-full max-w-md bg-white dark:bg-[#1a1a1a] rounded-2xl shadow-xl border border-gray-200 dark:border-[#2a2a2a] overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="account-modal-btn absolute top-4 right-4 p-2 text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 rounded-lg z-10"
          aria-label="Close"
        >
          <XMarkIcon className="w-5 h-5" />
        </button>

        <div className="p-6 pt-8 text-center">
          <div className="w-16 h-16 mx-auto rounded-xl flex items-center justify-center bg-gray-100 dark:bg-[#282828] border border-gray-200 dark:border-[#333] p-3 mb-4">
            {IconComponent ? (
              <IconComponent className="w-full h-full" style={{ color: connector.id === 'hubspot' ? '#FF7A59' : connector.id === 'github' ? (darkMode ? '#F0F0F0' : '#181717') : connector.id === 'notion' ? (darkMode ? '#F0F0F0' : '#000000') : 'currentColor' }} />
            ) : (
              <img src={imgSrc} alt={connector.label} className="w-full h-full object-contain" />
            )}
          </div>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2" style={{ fontFamily: 'var(--chat-font-family)' }}>
            {connector.label}
          </h3>
          {connector.description && (
            <p className="text-sm text-gray-500 dark:text-gray-400 mb-6" style={{ fontFamily: 'var(--chat-font-family)' }}>
              {connector.description}
            </p>
          )}
          <div className="mb-6">
            <button
              onClick={() => onDisconnect(connector)}
              disabled={disconnecting}
              className="account-modal-btn inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 disabled:opacity-50 disabled:cursor-not-allowed rounded-lg border border-red-200 dark:border-red-900/50"
            >
              {disconnecting ? (
                <>
                  <span className="w-4 h-4 border-2 border-red-300 border-t-red-600 dark:border-red-900/50 dark:border-t-red-400 rounded-full animate-spin" />
                  Disconnecting...
                </>
              ) : (
                'Disconnect'
              )}
            </button>
          </div>
        </div>

        <div className="px-6 pb-6 border-t border-gray-200 dark:border-[#2a2a2a] pt-4">
          <div className="space-y-3 text-sm">
            <div className="flex justify-between">
              <span className="text-gray-500 dark:text-gray-400">Connector Type</span>
              <span className="text-gray-900 dark:text-white">{connector.connectorType || 'App'}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-500 dark:text-gray-400">Author</span>
              <span className="text-gray-900 dark:text-white">{connector.author || 'Midus'}</span>
            </div>
            <div className="flex justify-between items-center gap-2">
              <span className="text-gray-500 dark:text-gray-400">UUID</span>
              <button
                type="button"
                onClick={() => {
                  if (connector.uuid) {
                    navigator.clipboard.writeText(connector.uuid);
                    toast.success('UUID copied to clipboard');
                  }
                }}
                className="p-1 text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 flex-shrink-0"
                aria-label="Copy UUID"
              >
                <DocumentDuplicateIcon className="w-4 h-4" />
              </button>
            </div>
            {connector.website && (
              <div className="flex justify-between items-center">
                <span className="text-gray-500 dark:text-gray-400">Website</span>
                <a href={connector.website} target="_blank" rel="noopener noreferrer" className="p-1 text-gray-500 hover:text-gray-700 dark:hover:text-gray-300">
                  <ArrowTopRightOnSquareIcon className="w-4 h-4" />
                </a>
              </div>
            )}
            <div className="flex justify-between items-center">
              <span className="text-gray-500 dark:text-gray-400">Privacy Policy</span>
              <a href={connector.privacyPolicy} target="_blank" rel="noopener noreferrer" className="p-1 text-gray-500 hover:text-gray-700 dark:hover:text-gray-300">
                <ArrowTopRightOnSquareIcon className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>

        <div className="px-6 pb-6 text-center">
          <button
            type="button"
            onClick={() => {
              window.dispatchEvent(new CustomEvent(OPEN_GLOBAL_FEEDBACK_EVENT, { detail: { connector: connector.label } }));
              onClose();
            }}
            className="text-sm text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 underline"
          >
            Provide feedback
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(detailContent, document.body);
}

/**
 * Connectors tab content for AccountModal. Manages connected connectors.
 * Uses cached data from parent so switching tabs doesn't refetch.
 */
function ManageConnectorsTab({ onClose, onAddConnectors, connectedConnectors = {}, connectorsLoading = false, onRefreshConnectors, darkMode }) {
  const [selectedConnector, setSelectedConnector] = useState(null);
  const [disconnecting, setDisconnecting] = useState(false);
  const [showConnectToolsModal, setShowConnectToolsModal] = useState(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      if (params.get('connectTools') === '1') return true;
      return localStorage.getItem('connectToolsModalOpen') === '1';
    } catch {
      return false;
    }
  });

  const handleAddConnectors = () => {
    setShowConnectToolsModal(true);
    try {
      localStorage.setItem('connectToolsModalOpen', '1');
      const params = new URLSearchParams(window.location.search);
      params.set('connectTools', '1');
      window.history.replaceState({}, '', `${window.location.pathname}?${params}`);
    } catch {}
  };

  const handleConnectToolsModalClose = () => {
    setShowConnectToolsModal(false);
    try {
      localStorage.removeItem('connectToolsModalOpen');
      const params = new URLSearchParams(window.location.search);
      params.delete('connectTools');
      const newSearch = params.toString();
      window.history.replaceState({}, '', newSearch ? `${window.location.pathname}?${newSearch}` : window.location.pathname);
    } catch {}
    onRefreshConnectors?.();
    // Notify ChatInput and tool selector to refresh (user may have connected something)
    window.dispatchEvent(new CustomEvent('connectors-updated', { detail: {} }));
  };

  const handleDisconnect = async (connector) => {
    const endpoint = getDisconnectEndpoint(connector.id);
    if (!endpoint) return;
    setDisconnecting(true);
    try {
      const token = localStorage.getItem('token');
      await axios.post(endpoint, {}, { headers: { Authorization: `Bearer ${token}` } });
      toast.success(`${connector.name} disconnected`);
      setSelectedConnector(null);
      onRefreshConnectors?.();
      // Notify ChatInput and tool selector to refresh
      window.dispatchEvent(new CustomEvent('connectors-updated', { detail: { disconnectedIds: [connector.id] } }));
    } catch (e) {
      console.error('Disconnect error:', e);
      toast.error('Failed to disconnect');
    } finally {
      setDisconnecting(false);
    }
  };

  const connectedOnly = CONNECTOR_APPS.filter((app) => (connectedConnectors || {})[app.id]);

  const scrollContent = connectorsLoading ? (
    <div className="space-y-1">
      {[1, 2, 3].map((i) => (
        <div key={i} className={`flex items-center gap-3 py-4 animate-pulse ${i < 3 ? 'border-b border-gray-200 dark:border-[#2a2a2a]' : ''}`}>
          <div className="w-10 h-10 rounded-lg bg-gray-200 dark:bg-[#333] flex-shrink-0" />
          <div className="flex-1 min-w-0">
            <div className="h-4 bg-gray-200 dark:bg-[#333] rounded w-32 mb-2" />
            <div className="h-3 bg-gray-200 dark:bg-[#333] rounded w-48" />
          </div>
        </div>
      ))}
    </div>
  ) : connectedOnly.length === 0 ? (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <p className="text-gray-500 dark:text-[#999999] mb-4" style={{ fontFamily: 'var(--chat-font-family)' }}>
        No connectors connected yet
      </p>
      <button
        type="button"
        onClick={handleAddConnectors}
        className="account-modal-btn inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white dark:text-gray-900 bg-gray-900 dark:bg-gray-200 hover:bg-gray-800 dark:hover:bg-gray-100 rounded-lg"
        style={{ fontFamily: 'var(--chat-font-family)' }}
      >
        <TbPlug className="w-[17px] h-[17px] opacity-90 dark:opacity-80 text-gray-600 dark:text-[#999999]" />
        Add connectors
      </button>
    </div>
  ) : (
    <div className="space-y-1">
      {connectedOnly.map((app, idx) => {
        const IconComponent = app.icon;
        const isLast = idx === connectedOnly.length - 1;
        return (
          <button
            key={app.id}
            type="button"
            onClick={() => setSelectedConnector(app)}
            className={`w-full flex items-center gap-3 py-4 px-3 transition-colors text-left group ${!isLast ? 'border-b border-gray-200 dark:border-[#2a2a2a]' : ''}`}
          >
            <div className="w-10 h-10 rounded-lg flex items-center justify-center bg-gray-100 dark:bg-[#282828] border border-gray-200 dark:border-[#333] flex-shrink-0 p-2">
              {IconComponent ? (
                <IconComponent className="w-full h-full" style={{ color: app.id === 'hubspot' ? '#FF7A59' : app.id === 'github' ? (darkMode ? '#F0F0F0' : '#181717') : app.id === 'notion' ? (darkMode ? '#F0F0F0' : '#000000') : 'currentColor' }} />
              ) : (
                <img src={app.src} alt={app.name} className="w-full h-full object-contain" />
              )}
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-medium text-gray-900 dark:text-white" style={{ fontFamily: 'var(--chat-font-family)' }}>
                {app.name}
              </div>
              <div className="text-sm text-gray-500 dark:text-[#999999] truncate" style={{ fontFamily: 'var(--chat-font-family)' }}>
                {app.description}
              </div>
            </div>
            <ChevronRightIcon className="w-5 h-5 text-gray-400 dark:text-[#666] group-hover:text-gray-600 dark:group-hover:text-gray-300 flex-shrink-0" />
          </button>
        );
      })}
    </div>
  );

  return (
    <>
      <div className="flex-1 min-h-0 overflow-y-auto px-4">
        {scrollContent}
      </div>
      {connectedOnly.length > 0 && (
        <div className="p-4 border-t border-gray-200 dark:border-[#2a2a2a] flex-shrink-0">
          <button
            type="button"
            onClick={handleAddConnectors}
            className="account-modal-btn w-full flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-[#252525] hover:bg-gray-200 dark:hover:bg-[#333] rounded-xl"
            style={{ fontFamily: 'var(--chat-font-family)' }}
          >
            <TbPlug className="w-[17px] h-[17px] opacity-70 dark:opacity-80 text-gray-600 dark:text-[#999999]" />
            Add connectors
          </button>
        </div>
      )}
      {selectedConnector && (
        <ConnectorDetailModal
          connector={selectedConnector}
          onClose={() => setSelectedConnector(null)}
          onDisconnect={handleDisconnect}
          disconnecting={disconnecting}
          darkMode={darkMode}
        />
      )}
      <ConnectToolsModal
        isOpen={showConnectToolsModal}
        onClose={handleConnectToolsModalClose}
        darkMode={darkMode}
      />
    </>
  );
}

export default ManageConnectorsTab;
